<script lang="ts" setup>
import type { SocialMediaPlatform } from "~/models/SocialMediaPlatform";

const data = await useLayout();
</script>

<template>
  <div v-if="data" class="flex flex-col gap-x-xl text-center sm:text-start lg:flex-row">
    <div v-if="data.footerSubtitle">
      {{ data.footerSubtitle }}
    </div>

    <div class="my-lg lg:my-0 lg:grow">
      <ul class="flex flex-col gap-xl sm:flex-row">
        <li v-for="footerLink in data.footerLinks" :key="footerLink.id">
          <NuxtLinkLocale
            :to="`/legal/${footerLink.slug}`"
            class="white-link font-normal"
          >
            {{ footerLink.title }}
          </NuxtLinkLocale>
        </li>
        <li>
          <NuxtLink
            id="alistar-ebizz"
            to="https://alistar.net/e-commerce"
            target="_blank"
            class="white-link font-normal"
            rel="noopener referrer"
          >
            E-business by Alistar
          </NuxtLink>
        </li>
      </ul>
    </div>

    <div class="mx-auto sm:mx-0">
      <ul class="my-lg flex gap-x-xl lg:my-0">
        <li v-for="item in data.socialMedia" :key="item.id">
          <SocialMediaIconLink :platform="(item.platform as SocialMediaPlatform)" :url="item.url" />
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped></style>
